import React, { useState, useEffect, Fragment } from 'react'
import { connect } from "react-redux"
import { Row, Col, Button, Form, Toast } from 'react-bootstrap'
import { IoIosClose, IoMdDoneAll } from "react-icons/io"
import axios from "axios"
import Loader from '../../../components/Loader'

// Local imports
import { _HttpServices } from '../../../_services/_HttpServices'
import endPoints from '../../../_services/endpoints'
import { env } from '../../../_services/env'

const DataSecurity = (props, { dispatch }) => {

    // props
    const task = props.task
    const editing = props.editing
    const viewTask = props.viewTask

    // States
    const [loader, setLoader] = useState(false)
    const [dataSecurityEditing, setDataSecurityEditing] = useState(false)
    const [dataSecurityUpdating, setDataSecurityUpdating] = useState(false)
    const [pGPEncryptionError, setPGPEncryptionError] = useState(false)
    const [showToaster, setShowToaster] = useState(false)
    const [errorToaster, setErrorToaster] = useState(false)
    const [validated, setValidated] = useState(false)
    const [submitBtnDisable, setSubmitBtnDisable] = useState(true)
    const [tasks, setTasks] = useState([])
    const [editingDataSecurity, setEditingDataSecurity] = useState(false)

    const initialState = {
        Id: 0, ClientId: "CIBD", TaskName: "Select Task",
        LocalFileEncryption: "Y", EcryptionMethod: "Select Ecryption Method", LocalFileEncryptionPassPhrase: "",
        PGPEncryption: "Y", InboundPublicKey: "", OutboundPublicKey: "",
        ZipFile: "Y", DecryptZipOrder: "Select Zip Order", ZipPassword: "",
        DataEncryption: "Y", DataEncryptionPassPhrase: "",
    }
    const [dataSecurity, setDataSecurity] = useState(initialState)

    useEffect(() => {
        // dispatch(fetchTasks())
        dataSecurityUpdate(dataSecurity)
    }, [dispatch, dataSecurity])

    useEffect(() => {
        getTasksData()
        if (editing || props.viewTask) {
            setLoader(true)
            dataSecurity.TaskName = task.Id
            getTaskDataById(task.Id)
        }
        setPGPEncryptionError(false)
    }, [])

    // Functions
    // ======================================================================================================= Get Tasks ============
    const getTasksData = async () => {
        await _HttpServices
            .getData("api/Services/All")
            .then((data) => {
                const res = data.data
                setTasks(res)
            }).catch(e=> {
                setLoader(false)
            
            })
    }

    // ======================================================================================================= Onchange Data Update ============
    const dataSecurityUpdate = (dataSecurity) => {
        // if(dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0){
        //     setEditingDataSecurity(true)
        // }

        // if (!editing) { }
        // Button enable disable
        if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "N" && dataSecurity.ZipFile === "N" && dataSecurity.DataEncryption === "N") {
            // LocalFileEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "N" && dataSecurity.DataEncryption === "N") {
            // LocalFileEncryption yes, PGPEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder > 0 && dataSecurity.ZipPassword.length > 0 && dataSecurity.DataEncryption === "N") {
            // LocalFileEncryption yes, PGPEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder > 0 && dataSecurity.ZipPassword.length > 0
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0) {
            // LocalFileEncryption yes, PGPEncryption yes, ZipFile yes, DataEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder === "0" && dataSecurity.ZipPassword.length === 0 && dataSecurity.DataEncryption === "N") {
            // LocalFileEncryption yes, PGPEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder === "0" && dataSecurity.ZipPassword.length === 0
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0) {
            // LocalFileEncryption yes, PGPEncryption yes, ZipFile yes, DataEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "N" && dataSecurity.DataEncryption === "N") {
            // LocalFileEncryption yes, PGPEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder > 0 && dataSecurity.ZipPassword.length > 0
            && dataSecurity.PGPEncryption === "N" && dataSecurity.DataEncryption === "N") {
            // LocalFileEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder === "0" && dataSecurity.ZipPassword.length === 0
            && dataSecurity.PGPEncryption === "N" && dataSecurity.DataEncryption === "N") {
            // LocalFileEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "N" && dataSecurity.ZipFile === "N") {
            // LocalFileEncryption yes, DataEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder > 0 && dataSecurity.ZipPassword.length > 0
            && dataSecurity.DataEncryption === "N") {
            // LocalFileEncryption yes, PGPEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder === "0" && dataSecurity.ZipPassword.length === 0
            && dataSecurity.DataEncryption === "N") {
            // LocalFileEncryption yes, PGPEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.ZipFile === "N") {
            // LocalFileEncryption yes, PGPEncryption yes, DataEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder > 0 && dataSecurity.ZipPassword.length > 0
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "N") {
            // LocalFileEncryption yes, DataEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder === "0" && dataSecurity.ZipPassword.length === 0
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "N") {
            // LocalFileEncryption yes, DataEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder > 0 && dataSecurity.ZipPassword.length > 0
            && dataSecurity.DataEncryption === "N") {
            // LocalFileEncryption yes, PGPEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder === "0" && dataSecurity.ZipPassword.length === 0
            && dataSecurity.DataEncryption === "N") {
            // LocalFileEncryption yes, PGPEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder > 0 && dataSecurity.ZipPassword.length > 0
            && dataSecurity.PGPEncryption === "N") {
            // LocalFileEncryption yes, DataEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder === "0" && dataSecurity.ZipPassword.length === 0
            && dataSecurity.PGPEncryption === "N") {
            // LocalFileEncryption yes, DataEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.LocalFileEncryption === "Y" && dataSecurity.EcryptionMethod !== "Select Ecryption Method" && dataSecurity.LocalFileEncryptionPassPhrase.length > 0
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.ZipFile === "N") {
            // LocalFileEncryption yes, PGPEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.LocalFileEncryption === "N" && dataSecurity.ZipFile === "N" && dataSecurity.DataEncryption === "N") {
            // PGPEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder > 0 && dataSecurity.ZipPassword.length > 0
            && dataSecurity.LocalFileEncryption === "N" && dataSecurity.DataEncryption === "N") {
            // PGPEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder === "0" && dataSecurity.ZipPassword.length === 0
            && dataSecurity.LocalFileEncryption === "N" && dataSecurity.DataEncryption === "N") {
            // PGPEncryption yes, ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.LocalFileEncryption === "N" && dataSecurity.ZipFile === "N") {
            // PGPEncryption yes, DataEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder > 0 && dataSecurity.ZipPassword.length > 0
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.LocalFileEncryption === "N") {
            // PGPEncryption yes, ZipFile yes, DataEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.PGPEncryption === "Y" && (dataSecurity.InboundPublicKey.length > 0 || dataSecurity.OutboundPublicKey.length > 0)
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder === "0" && dataSecurity.ZipPassword.length === 0
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.LocalFileEncryption === "N") {
            // PGPEncryption yes, ZipFile yes, DataEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder > 0 && dataSecurity.ZipPassword.length > 0 && dataSecurity.DataEncryption === "N"
            && dataSecurity.LocalFileEncryption === "N" && dataSecurity.PGPEncryption === "N") {
            // ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder === "0" && dataSecurity.ZipPassword.length === 0 && dataSecurity.DataEncryption === "N"
            && dataSecurity.LocalFileEncryption === "N" && dataSecurity.PGPEncryption === "N") {
            // ZipFile yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder > 0 && dataSecurity.ZipPassword.length > 0
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.LocalFileEncryption === "N" && dataSecurity.PGPEncryption === "N") {
            // ZipFile yes, DataEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.ZipFile === "Y" && dataSecurity.DecryptZipOrder === "0" && dataSecurity.ZipPassword.length === 0
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.LocalFileEncryption === "N" && dataSecurity.PGPEncryption === "N") {
            // ZipFile yes, DataEncryption yes
            setSubmitBtnDisable(false)
        } else if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
            && dataSecurity.DataEncryption === "Y" && dataSecurity.DataEncryptionPassPhrase.length > 0
            && dataSecurity.LocalFileEncryption === "N" && dataSecurity.LocalFileEncryption === "N"
            && dataSecurity.ZipFile === "N") {
            // DataEncryption yes
            setSubmitBtnDisable(false)
        } else {
            setSubmitBtnDisable(true)
        }

        if (editing || dataSecurityEditing) {
            if (dataSecurity.ClientId !== "Select Client" && dataSecurity.TaskName !== "Select Task"
                && dataSecurity.DataEncryption === "N" && dataSecurity.ZipFile === "N"
                && dataSecurity.LocalFileEncryption === "N" && dataSecurity.LocalFileEncryption === "N") {
                setSubmitBtnDisable(false)
            }
        }

        if (dataSecurity.DecryptZipOrder < 1) {
            dataSecurity.ZipPassword = ""
        }

    }

    // Trim values
    const trimValue = event => {
        const { name, value } = event.target
        setDataSecurity({ ...dataSecurity, [name]: value.trim() })
    }

    // ======================================================================================================= Input Change Handler ============
    const handleInputChange = event => {
        const { name, value } = event.target
        setDataSecurity({ ...dataSecurity, [name]: value })

        if (name === "InboundPublicKey" || name === "OutboundPublicKey") {
            if (value.length > 0) {
                setPGPEncryptionError(false)
            } else {
                setPGPEncryptionError(true)
            }
        }
    }

    const handleOnChangeTask = async (event) => {
        setLoader(true)
        const { name, value } = event.target
        // await setDataSecurity({ ...dataSecurity, [name]: value })
        const taskIdValue = Number(value)
        // alert(taskIdValue)
        getTaskDataById(taskIdValue)
    }

    const getTaskDataById = async (id) => {
        try{
        const response = await axios.get(endPoints.editTask + id)
        const data = await response.data
        
        if (env.debug) {
            console.log("Edit Data Security Data *******************************")
            console.log(data)
        }

        if (data.IsLocalFileEncryptionSupported === null || data.IsLocalFileEncryptionSupported === false || data.IsLocalFileEncryptionSupported === "N") {
            data.IsLocalFileEncryptionSupported = "N"
            dataSecurity.EcryptionMethod = "Select Ecryption Method"
        } else {
            data.IsLocalFileEncryptionSupported = "Y"
        }
        if (data.PassPhrase === null) {
            data.PassPhrase = ""
        }
        if (data.IsFileEncrypted === null || data.IsFileEncrypted === false || data.IsFileEncrypted === "N") {
            data.IsFileEncrypted = "N"
        } else {
            data.IsFileEncrypted = "Y"
        }
        if (data.InboundPublicKey === null) {
            data.InboundPublicKey = ""
        }
        if (data.PrivateKeyFilePath === null) {
            data.PrivateKeyFilePath = ""
        }
        if (data.IsFileZipped === null || data.IsFileZipped === false || data.IsFileZipped === "N") {
            data.IsFileZipped = "N"
        }
        if (data.ZipPassword === null) {
            data.ZipPassword = ""
        }
        if (data.IsPHIEncrypted === null || data.IsPHIEncrypted === false || data.IsPHIEncrypted === "N") {
            data.IsPHIEncrypted = "N"
        } else {
            data.IsPHIEncrypted = "Y"
        }
        if (data.EncryptionPassCode === null) {
            data.EncryptionPassCode = ""
        }
        if (data.DecryptZipOrder === null) {
            data.DecryptZipOrder = "Select Zip Order"
        }

        // if(
        //     (data.EcryptionMethod !== null && data.EncryptionPassCode !== null) ||
        //     data.InboundPublicKey.length > 0 || data.PrivateKeyFilePath.length > 0 ||
        //     data.DecryptZipOrder !== "Select Zip Order" ||
        //     data.PassPhrase.length > 0
        // ){
        //     setEditingDataSecurity(true)
        // }

        // EcryptionMethod: dataSecurity.EcryptionMethod,
        // DecryptZipOrder: dataSecurity.DecryptZipOrder,
        setDataSecurity({
            ...dataSecurity,
            TaskName: data.Id,
            LocalFileEncryption: data.IsLocalFileEncryptionSupported,
            EcryptionMethod: data.EcryptionMethod,
            LocalFileEncryptionPassPhrase: data.EncryptionPassCode,
            PGPEncryption: data.IsFileEncrypted,
            InboundPublicKey: data.InboundPublicKey,
            OutboundPublicKey: data.PrivateKeyFilePath,
            ZipFile: data.IsFileZipped,
            DecryptZipOrder: data.DecryptZipOrder,
            ZipPassword: data.ZipPassword,
            DataEncryption: data.IsPHIEncrypted,
            DataEncryptionPassPhrase: data.PassPhrase
        })

        if (env.debug) {
            console.log("data Set ******************************")
            console.log(dataSecurity)
        }

        if (data.EncryptionPassCode.length > 0 || data.InboundPublicKey.length > 0 || data.PrivateKeyFilePath.length > 0 ||
            data.ZipPassword.length > 0 || data.PassPhrase.length > 0) {
            setDataSecurityEditing(true)
            setDataSecurityUpdating(true)
        } else {
            setDataSecurityEditing(false)
            setDataSecurityUpdating(false)
        }
        setLoader(false)
        } catch(error) {
            setLoader(false);
        }
    }

    const handleLocalFileEncryptionChange = (data) => {
        if (editing || dataSecurityEditing) {
            if (data.LocalFileEncryption === "N") {
                setDataSecurity({ ...dataSecurity, LocalFileEncryption: "N", EcryptionMethod: dataSecurity.EcryptionMethod, LocalFileEncryptionPassPhrase: dataSecurity.LocalFileEncryptionPassPhrase })
            } else {
                setDataSecurity({ ...dataSecurity, LocalFileEncryption: "Y" })
            }
        } else {
            if (data.LocalFileEncryption === "N") {
                setDataSecurity({ ...dataSecurity, LocalFileEncryption: "N", EcryptionMethod: "Select Ecryption Method", LocalFileEncryptionPassPhrase: "" })
            } else {
                setDataSecurity({ ...dataSecurity, LocalFileEncryption: "Y" })
            }
        }
    }

    const handlePGPEncryptionChange = (data) => {
        if (editing || dataSecurityEditing) {
            if (data.PGPEncryption === "N") {
                setPGPEncryptionError(false)
                setDataSecurity({ ...dataSecurity, PGPEncryption: "N", InboundPublicKey: dataSecurity.InboundPublicKey, OutboundPublicKey: dataSecurity.OutboundPublicKey })
            } else {
                setDataSecurity({ ...dataSecurity, PGPEncryption: "Y" })
            }
        } else {
            if (data.PGPEncryption === "N") {
                setPGPEncryptionError(false)
                setDataSecurity({ ...dataSecurity, PGPEncryption: "N", InboundPublicKey: "", OutboundPublicKey: "" })
            } else {
                setDataSecurity({ ...dataSecurity, PGPEncryption: "Y" })
            }
        }
    }

    const handleZipFileChange = (data) => {
        if (editing || dataSecurityEditing) {
            if (data.ZipFile === "N") {
                setDataSecurity({ ...dataSecurity, ZipFile: "N", DecryptZipOrder: dataSecurity.DecryptZipOrder, ZipPassword: dataSecurity.ZipPassword })
            } else {
                setDataSecurity({ ...dataSecurity, ZipFile: "Y" })
            }
        } else {
            if (data.ZipFile === "N") {
                setDataSecurity({ ...dataSecurity, ZipFile: "N", DecryptZipOrder: "Select Zip Order", ZipPassword: "" })
            } else {
                setDataSecurity({ ...dataSecurity, ZipFile: "Y" })
            }
        }
    }

    const handleDataEncryptionChange = (data) => {
        if (editing || dataSecurityEditing) {
            if (data.DataEncryption === "N") {
                setDataSecurity({ ...dataSecurity, DataEncryption: "N", DataEncryptionPassPhrase: dataSecurity.DataEncryptionPassPhrase })
            } else {
                setDataSecurity({ ...dataSecurity, DataEncryption: "Y" })
            }
        } else {
            if (data.DataEncryption === "N") {
                setDataSecurity({ ...dataSecurity, DataEncryption: "N", DataEncryptionPassPhrase: "" })
            } else {
                setDataSecurity({ ...dataSecurity, DataEncryption: "Y" })
            }
        }
    }

    // ======================================================================================================= Submit Handler ============
    const submitDataSecurity = async () => {
        setLoader(true)
        let TaskId = Number(dataSecurity.TaskName)
        if (dataSecurity.LocalFileEncryption === "N") {
            dataSecurity.EcryptionMethod = ""
            dataSecurity.LocalFileEncryptionPassPhrase = ""
        }
        if (dataSecurity.PGPEncryption === "N") {
            dataSecurity.InboundPublicKey = ""
            dataSecurity.OutboundPublicKey = ""
        }
        if (dataSecurity.DecryptZipOrder === "Select Zip Order" || dataSecurity.ZipFile === "N") {
            dataSecurity.DecryptZipOrder = null
            dataSecurity.ZipPassword = ""
        } else {
            dataSecurity.DecryptZipOrder = Number(dataSecurity.DecryptZipOrder)
        }
        if (dataSecurity.DataEncryption === "N") {
            dataSecurity.DataEncryptionPassPhrase = ""
        }

        const apiObj = {
            Id: TaskId,
            // ClientID: 109,
            // TaskName: dataSecurity.TaskName,
            IsLocalFileEncryptionSupported: dataSecurity.LocalFileEncryption,
            EcryptionMethod: dataSecurity.EcryptionMethod,
            EncryptionPassCode: dataSecurity.LocalFileEncryptionPassPhrase,
            IsFileEncrypted: dataSecurity.PGPEncryption,
            InboundPublicKey: dataSecurity.InboundPublicKey,
            PrivateKeyFilePath: dataSecurity.OutboundPublicKey,
            IsFileZipped: dataSecurity.ZipFile,
            DecryptZipOrder: dataSecurity.DecryptZipOrder,
            ZipPassword: dataSecurity.ZipPassword,
            IsPHIEncrypted: dataSecurity.DataEncryption,
            PassPhrase: dataSecurity.DataEncryptionPassPhrase
        }

        const loggedInUserData = JSON.parse(localStorage.getItem('userData'));
        if (loggedInUserData) {
            if (loggedInUserData.Token) {
                axios.defaults.headers['ApplicationSecurityCode'] = loggedInUserData.ApplicationSecurityCode;
                axios.defaults.headers.common['SECURIT_IDENTITY'] = loggedInUserData.Token;
            }
        }

        if (env.debug) {
            console.log("Data Security Obj")
            console.log(apiObj)
        }

        await axios.post(endPoints.updateDataSecurity, apiObj)
            .then((res) => {
                setLoader(false)
                setShowToaster(true)
                // alert("Successfully created")
                if (dataSecurity) {
                    setDataSecurityEditing(false)
                }
                props.cancelHandler()
            })
            .catch((error) => {
                setLoader(false)
                setErrorToaster(true)
                console.log(error.message)
                // alert("Not created")
            })
    }

    const submitHandler = (event) => {
        const form = event.currentTarget
        if (form.checkValidity() === false) {
            event.preventDefault()
            event.stopPropagation()
        } else {
            event.preventDefault()
            if (dataSecurity.PGPEncryption === "Y" && dataSecurity.InboundPublicKey.length === 0 && dataSecurity.OutboundPublicKey.length === 0) {
                setPGPEncryptionError(true)
                return false
            }

            submitDataSecurity()
        }

        setValidated(true)
        setErrorToaster(false)
    }

    // ======================================================================================================= Add Submit Handler ============
    const addSubmitHandler = async () => { }

    // ======================================================================================================= Edit Submit Handler ============
    const editSubmitHandler = () => { }

    return (
        <Fragment>
            {loader ? <Loader /> : null}

            {/* Toaster */}
            <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className={errorToaster ? "custom-toaster err-toaster" : "custom-toaster"}>
                {/* <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header> */}
                <Toast.Body>
                    {errorToaster ? "Not updated data security." : dataSecurityUpdating ? "Successfully updated data security." : "Successfully added data security."}
                </Toast.Body>
            </Toast>

            <div className="tab-inner">
                <Form className="form" noValidate validated={validated} onSubmit={submitHandler}>
                    <Row>
                        <Col md={12}>
                            <h5 className="h5 mt-3">Data Security</h5>
                        </Col>

                        <Col md={6}>
                            <Form.Group>
                                <Form.Label htmlFor="ClientID">
                                    Client Name<span className="required">*</span>
                                </Form.Label>
                                <Form.Control as="select" required disabled name="ClientId" value={dataSecurity.ClientId} onBlur={trimValue} onChange={handleInputChange}>
                                    <option disabled hidden>Select Client</option>
                                    <option>CIBD</option>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">Please select client.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label htmlFor="TaskName">
                                    Task Name<span className="required">*</span>
                                </Form.Label>
                                <Form.Control as="select" required disabled={viewTask ? viewTask : props.editDisable} name="TaskName" value={dataSecurity.TaskName} onChange={handleOnChangeTask}>
                                    <option disabled hidden>Select Task</option>
                                    <Fragment>
                                        {tasks.length > 0 ? tasks.map(task => {
                                            return <option key={task.Id} value={task.Id}>{task.TaskName}</option>
                                        }) : null}
                                    </Fragment>
                                </Form.Control>
                                <Form.Control.Feedback type="invalid">Please Select Task.</Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        {/* Local File Encryption */}
                        <Col md={12}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label htmlFor="LocalFileEncryption">Local File Encryption</Form.Label>
                                        <div>
                                            <Form.Check custom inline disabled={viewTask} label="Yes" type="radio" name="LocalFileEncryption" id="LocalFileEncryptionYes" value="Y" checked={dataSecurity.LocalFileEncryption === 'Y'} onChange={(event) => handleLocalFileEncryptionChange({ ...dataSecurity, LocalFileEncryption: event.target.value })} />
                                            <Form.Check custom inline disabled={viewTask} label="No" type="radio" name="LocalFileEncryption" id="LocalFileEncryptionNo" value="N" checked={dataSecurity.LocalFileEncryption === 'N'} onChange={(event) => handleLocalFileEncryptionChange({ ...dataSecurity, LocalFileEncryption: event.target.value })} />
                                        </div>
                                        <Form.Control.Feedback type="invalid">Please select local file encryption.</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                {dataSecurity.LocalFileEncryption === "Y" ?
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label htmlFor="ClientID">
                                                Ecryption Method<span className="required">*</span>
                                            </Form.Label>
                                            <Form.Control as="select" required disabled={viewTask} name="EcryptionMethod" value={dataSecurity.EcryptionMethod} onBlur={trimValue} onChange={handleInputChange}>
                                                <option disabled hidden>Select Ecryption Method</option>
                                                <option value="AES">AES</option>
                                                <option value="3DES">3DES</option>
                                                <option value="BLOWFISH">BLOWFISH</option>
                                                <option value="RC4">RC4</option>
                                                <option value="RC5">RC5</option>
                                            </Form.Control>
                                            <Form.Control.Feedback type="invalid">Please select ecryption method.</Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group>
                                            <Form.Label htmlFor="LocalFileEncryptionPassPhrase">Pass Phrase<span className="required">*</span></Form.Label>
                                            <Form.Control type="text" required disabled={viewTask} name="LocalFileEncryptionPassPhrase" value={dataSecurity.LocalFileEncryptionPassPhrase} min="1" maxLength="50" onBlur={trimValue} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">Please enter pass phrase.</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col> : null}
                            </Row>
                        </Col>
                        {/* PGP Encryption */}
                        <Col md={12}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label htmlFor="PGPEncryption">PGP Encryption</Form.Label>
                                        <div>
                                            <Form.Check custom inline disabled={viewTask} label="Yes" type="radio" name="PGPEncryption" id="PGPEncryptionYes" value="Y" checked={dataSecurity.PGPEncryption === 'Y'} onChange={(event) => handlePGPEncryptionChange({ ...dataSecurity, PGPEncryption: event.target.value })} />
                                            <Form.Check custom inline disabled={viewTask} label="No" type="radio" name="PGPEncryption" id="PGPEncryptionNo" value="N" checked={dataSecurity.PGPEncryption === 'N'} onChange={(event) => handlePGPEncryptionChange({ ...dataSecurity, PGPEncryption: event.target.value })} />
                                        </div>
                                        <Form.Control.Feedback type="invalid">Please select local file encryption.</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                {dataSecurity.PGPEncryption === "Y" ?
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label htmlFor="InboundPublicKey">Inbound Public Key</Form.Label>
                                            <Form.Control type="text" disabled={viewTask} name="InboundPublicKey" value={dataSecurity.InboundPublicKey} min="1" maxLength="50" onBlur={trimValue} onChange={handleInputChange} className={pGPEncryptionError && "form-control is-invalid"} />
                                            {/* <Form.Control.Feedback type="invalid">Please enter inbound public key.</Form.Control.Feedback> */}
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label htmlFor="OutboundPublicKey">Outbound Public Key</Form.Label>
                                            <Form.Control type="text" disabled={viewTask} name="OutboundPublicKey" value={dataSecurity.OutboundPublicKey} min="1" maxLength="50" onBlur={trimValue} onChange={handleInputChange} className={pGPEncryptionError && "form-control is-invalid"} />
                                            {/* <Form.Control.Feedback type="invalid">Please enter outbound public key.</Form.Control.Feedback> */}
                                            {pGPEncryptionError ? <Form.Control.Feedback type="invalid" className="d-block">Please enter inbound or outbound public key or both.</Form.Control.Feedback> : null}
                                        </Form.Group>

                                    </Col> : null}
                            </Row>
                        </Col>
                        {/* Zip File */}
                        <Col md={12}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label htmlFor="ZipFile">Zip File</Form.Label>
                                        <div>
                                            <Form.Check custom inline disabled={viewTask} label="Yes" type="radio" name="ZipFile" id="ZipFileYes" value="Y" checked={dataSecurity.ZipFile === 'Y'} onChange={(event) => handleZipFileChange({ ...dataSecurity, ZipFile: event.target.value })} />
                                            <Form.Check custom inline disabled={viewTask} label="No" type="radio" name="ZipFile" id="ZipFileNo" value="N" checked={dataSecurity.ZipFile === 'N'} onChange={(event) => handleZipFileChange({ ...dataSecurity, ZipFile: event.target.value })} />
                                        </div>
                                        <Form.Control.Feedback type="invalid">Please select zip file.</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                {dataSecurity.ZipFile === "Y" ?
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label htmlFor="ClientID">
                                                Zip Order<span className="required">*</span>
                                            </Form.Label>
                                            <Form.Control as="select" required disabled={viewTask} name="DecryptZipOrder" value={dataSecurity.DecryptZipOrder} onBlur={trimValue} onChange={handleInputChange}>
                                                <option disabled hidden>Select Zip Order</option>
                                                <option value="0">Zip Only</option>
                                                <option value="1">Zip & Encrypt</option>
                                                <option value="2">Encrypt & Zip</option>
                                            </Form.Control>
                                            <Form.Control.Feedback type="invalid">Please zip order.</Form.Control.Feedback>
                                        </Form.Group>

                                        <Fragment>
                                            {dataSecurity.DecryptZipOrder > 0 ?
                                                <Form.Group>
                                                    <Form.Label htmlFor="ZipPassword">Zip Password<span className="required">*</span></Form.Label>
                                                    <Form.Control type="text" required disabled={viewTask} name="ZipPassword" value={dataSecurity.ZipPassword} min="1" maxLength="50" onBlur={trimValue} onChange={handleInputChange} />
                                                    <Form.Control.Feedback type="invalid">Please enter zip password.</Form.Control.Feedback>
                                                </Form.Group> : null}
                                        </Fragment>
                                    </Col> : null}
                            </Row>
                        </Col>
                        {/* Data Encryption */}
                        <Col md={12}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label htmlFor="DataEncryption">Data Encryption</Form.Label>
                                        <div>
                                            <Form.Check custom inline disabled={viewTask} label="Yes" type="radio" name="DataEncryption" id="DataEncryptionYes" value="Y" checked={dataSecurity.DataEncryption === 'Y'} onChange={(event) => handleDataEncryptionChange({ ...dataSecurity, DataEncryption: event.target.value })} />
                                            <Form.Check custom inline disabled={viewTask} label="No" type="radio" name="DataEncryption" id="DataEncryptionNo" value="N" checked={dataSecurity.DataEncryption === 'N'} onChange={(event) => handleDataEncryptionChange({ ...dataSecurity, DataEncryption: event.target.value })} />
                                        </div>
                                        <Form.Control.Feedback type="invalid">Please select data encryption.</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                {dataSecurity.DataEncryption === "Y" ?
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label htmlFor="DataEncryptionPassPhrase">Pass Phrase<span className="required">*</span></Form.Label>
                                            <Form.Control type="text" required disabled={viewTask} name="DataEncryptionPassPhrase" value={dataSecurity.DataEncryptionPassPhrase} min="1" maxLength="50" onBlur={trimValue} onChange={handleInputChange} />
                                            <Form.Control.Feedback type="invalid">Please enter pass phrase.</Form.Control.Feedback>
                                        </Form.Group>
                                    </Col> : null}
                            </Row>
                        </Col>
                        <Col md={12}>
                            <Form.Group>
                                <div className="text-right">
                                    <Button type="submit" disabled={viewTask ? viewTask : submitBtnDisable}><IoMdDoneAll className="icon btn-icon" />{editing || dataSecurityEditing ? "Update" : "Submit"}</Button>
                                    <Button variant="danger" className="cancel-btn ml-3" onClick={() => props.cancelHandler()}><IoIosClose className="icon btn-icon" />Cancel</Button>
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </div>
        </Fragment>
    )
}


// Map Redux state to React component props
const mapStateToProps = (state) => ({
    tasks: state.tasks.tasks
});

// Connect Redux to React
export default connect(mapStateToProps)(DataSecurity)